import { useCallback, useState } from 'react'
import { NotificationModel, NotificationsApiHandler } from '../types'
import { notificationHubService } from '../services'
import { useToast } from '@celebration/react'
import { getMessageFromApiError } from '../../../api/utils'
import { ApiError } from '../../../api/types'

const useNotificationHubApi = (): NotificationsApiHandler => {
  const [isLoading, setIsLoading] = useState(false)
  const [notifications, setNotifications] = useState<NotificationModel[]>([])
  const { openToast } = useToast()

  const updateNotifications = useCallback(async () => {
    setIsLoading(true)
    try {
      const result = await notificationHubService.getNotifications()
      if (result) setNotifications(result)
    } catch (error) {
      openToast({
        title: 'Erro ao buscar notificações',
        description: getMessageFromApiError(error as ApiError),
        type: 'negative',
      })
    } finally {
      setIsLoading(false)
    }
  }, [openToast])

  return { isLoading, notifications, updateNotifications }
}

export default useNotificationHubApi
